<template>
    <tooltip
        :text="text"
        :no-margin="noMargin"
        :align="align"
        :placement="placement"
        :color="color"
        :icon="icon"
        :size="size"
        class="hint"
        :focus-driven="false"
        :hover-driven="false"
        closable
        v-model="localValue"
    >
        <slot />
    </tooltip>
</template>
<script>
import { ref } from 'vue';
import Tooltip from './Tooltip.vue';

export default {
    name: 'Hint',
    props: {
        text: {
            type: String,
            required: false,
        },
        color: {
            type: String,
            default: 'gray',
            validate: (val) => !val && ['info', 'white', 'gray'].includes(val),
        },
        noMargin: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: 'info',
            validate: (val) => !val && ['info', 'question', 'alert'].includes(val),
        },
        size: {
            type: String,
            default: 'md',
            validate: (val) => !val && ['md', 'lg'].includes(val),
        },
        hoverDriven: {
            type: Boolean,
            default: true,
        },
        clickDriven: {
            type: Boolean,
            default: true,
        },
        focusDriven: {
            type: Boolean,
            default: true,
        },
        closeOnClickOutside: {
            type: Boolean,
            default: true,
        },
        align: {
            type: String,
            default: 'end',
            validator: (val) => ['start', 'end', 'center'].includes(val),
        },
        placement: {
            type: String,
            default: 'top',
            validator: (val) => ['top', 'bottom', 'left', 'right'].includes(val),
        },
    },
    components: {
        Tooltip,
    },
    setup() {
        const localValue = ref(false);

        return {
            localValue,
        };
    },
};
</script>
